module.exports = __webpack_public_path__ + "static/media/heart.f6de3005.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/heart.svg
// module id = 75
// module chunks = 0